module.exports = __webpack_public_path__ + "img/1572907016.a0080920.jpg";